import { css } from 'aphrodite/no-important';
import React, { FC } from 'react';
// styles
import { style } from './style';

interface RedButtonProps {
  className?: any;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
}

export const RedButton: FC<RedButtonProps> = ({ className, onClick, children }) => {
  const styles = style();

  return (
    <button className={`${className} ${css(styles.btn)}`} onClick={onClick}>
      {children}
    </button>
  );
};
